import { instance as axios, setJwtToken } from "../../config/axiosInstance";

const BASE = "/admin/activity-log";

export const getActivityLogsApi = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") query.append(k, v);
  });
  return await axios.get(`${BASE}/list?${query.toString()}`, setJwtToken());
};

export const getActivityStatsApi = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") query.append(k, v);
  });
  return await axios.get(`${BASE}/stats?${query.toString()}`, setJwtToken());
};

export const getActivityAdminListApi = async () => {
  return await axios.get(`${BASE}/admin-list`, setJwtToken());
};

export const trackActivityApi = async (data) => {
  return await axios.post(`${BASE}/track`, data, setJwtToken());
};

export const clearOldLogsApi = async (olderThanDays = 90) => {
  return await axios.delete(`${BASE}/clear`, {
    ...setJwtToken(),
    data: { olderThanDays },
  });
};
